// API Configuration
export const API_CONFIG = {
  BASE_URL_FOR_CHAT: "https://ai-chatboat.camascent.com",
  BASE_URL_FOR_BACKEND: "https://ai.camascent.com/api",
  // BASE_URL_FOR_BACKEND: "http://192.168.1.67:8000/api",
  TIMEOUT: 0, // No timeout - wait for API response
  CHAT_TIMEOUT: 0, // No timeout for chat/AI operations
};

// API Endpoints
export const API_ENDPOINTS = {
  SURVEY: "/zoho-response",
  GENERATE_QUESTIONS: "/generate-questions",
  CHAT: "/chat",
};

// Error Messages
export const ERROR_MESSAGES = {
  INVALID_SURVEY_ID: "Invalid survey ID",
  SURVEY_FETCH_FAILED:
    "Failed to load survey data. Please check the survey ID.",
  QUESTIONS_GENERATION_FAILED:
    "Failed to generate questions. Please try again.",
  CHAT_MESSAGE_FAILED: "Failed to send message. Please try again.",
  NETWORK_ERROR: "Network error. Please check your connection.",
};

// UI Messages
export const UI_MESSAGES = {
  LOADING_SURVEY: "Loading survey data...",
  INITIALIZING_CHAT: "Initializing chat...",
  TRANSCRIBING_AUDIO: "Transcribing audio...",
  TYPE_MESSAGE_PLACEHOLDER: "Type your message here...",
  SURVEY_COMPLETE: "Thank you for completing the survey! Here's your summary:",
  SURVEY_THANK_YOU: "Thank you for participating in our survey!",
};

// Chat Configuration
export const CHAT_CONFIG = {
  MESSAGE_INPUT_HEIGHT: "80px",
  PROGRESS_UPDATE_INTERVAL: 1000,
  SCROLL_BEHAVIOR: "smooth",
};

// Audio Recording Configuration
export const AUDIO_CONFIG = {
  VOICE_MESSAGE_TEXT: "Voice message",
  RECORDING_TIMER_FORMAT: "10px",
};
